const template = `<div class="col-lg-4 col-md-6 col-12">
<div class="index-block">
  <div class="index-block__title">{title}</div>
  <p>{text}</p>
</div>
</div>`;

function formatText(stringWithPlaceholders, replacements) {
  return stringWithPlaceholders.replace(/{(\w+)}/g, (placeholderWithDelimiters, placeholderWithoutDelimiters) =>
    replacements.hasOwnProperty(placeholderWithoutDelimiters)
      ? replacements[placeholderWithoutDelimiters]
      : placeholderWithDelimiters
  );
}

class GoalsPreview extends HTMLElement {
  set content(data) {
    this.setAttribute('content', data);
    console.log('set attribute ', data);
  }
  get content() {
    return this.hasAttribute('content');
  }
  static get observedAttributes() {
    return ['content'];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'content':
        this.render(newValue);
        break;
    }
  }
  render(data) {
    const parsedData = JSON.parse(data);
    this.innerHTML = '';
    parsedData.forEach((story) => {
      this.innerHTML += formatText(template, story);
    });
  }
}

customElements.define('custom-solution-goals', GoalsPreview);
